// @flow
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'
import EditCompany from '../components/AdminCompanyList/EditCompany'
import * as actions from '../actions'

import type {MapStateToProps, MapDispatchToProps} from 'react-redux'
import type {State, Action} from 'modules/Common/types'
import type {Match, RouterHistory} from 'react-router'
import type {AdminState} from '../types/index'

export type OwnProps = {
  match: ?Match,
  history: RouterHistory,
  location: {
    pathname: string
  }
};

export type StateProps = {
  companies: $PropertyType<AdminState, 'companies'>,
  isLoadingCompanies: $PropertyType<AdminState, 'isLoadingCompanies'>,
  error: $PropertyType<AdminState, 'error'>,
  companyProfile: $PropertyType<AdminState, 'companyProfile'>
};

export type DispatchProps = {
  getCompanies: $PropertyType<typeof actions, 'getCompanies'>,
  addOrUpdateCompany: $PropertyType<typeof actions, 'addOrUpdateCompany'>,
  getCompanyProfile: $PropertyType<typeof actions, 'getCompanyProfile'>
};

const mapStateToProps: MapStateToProps<State, OwnProps, StateProps> = (
  state: State
) => {
  return {
    companies: state.admin.companies,
    isLoadingCompanies: state.admin.isLoadingCompanies,
    error: state.admin.error,
    companyProfile: state.admin.companyProfile
  }
}
const mapDispatchToProps: MapDispatchToProps<Action<*>,
  OwnProps,
  DispatchProps> = dispatch => bindActionCreators({...actions}, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EditCompany)
